import React from 'react';
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import ADSContentLeft from "./Component/ADSContentLeft";
import ADSContentRight from "./Component/ADSContentRight";

const ADSContent = () => {
  return (
    <Box sx={{flexGrow: 1}}>
      <Grid container spacing={2}>
        <Grid xs={5}>
          <ADSContentLeft/>
        </Grid>

        <Grid xs={7}>
          <ADSContentRight/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ADSContent;
